import React, { Fragment, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
import { type } from "os";
import { json } from "d3";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import InputMask from "../App/InputMask";
import {
  getAccessSettings,
  removeNonNumeric,
  SortTheList,
} from "../Shared/Utility";
import DonutChart from "../Charts/DonutChart";
import * as XLSX from "xlsx";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
export default function ConditionalHoldHistory() {
  const globalState = useGlobalState();

  const [showAnimation, setShowAnimation] = useState(false);

  const [programDashboardFilter, setProgramDashboardFilter] = useState({
    ProgramID: 0,
    QuarterID: 0,
    PFIDealerID: 0,
    IBBScorecardID: 0,
    PFIGroupIDs: "1",
  });

  const [programList, setProgramList] = useState<any>([]);
  const [programData, setProgramData] = useState({}) as any;

  const [quarterList, setQuarterList] = useState<any>([]);

  const [groupList, setGroupList] = useState<any>([]);

  const [criteriaList, setCriteriaList] = useState<any>([]);
  const [inputData, setInputData] = useState<any>([]);

  const [totalData, setTotalData] = useState<any>([]);
  const [totalDataRows, setTotalDataRows] = useState<any>([{ Name: "Total" }]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") {
      IBBProgramID = Number(IBBProgramID);
      setProgramDashboardFilter((prevState: any) => ({
        ...prevState,
        ProgramID: IBBProgramID,
      }));
      IBBProgramGetProgramListForScorecard(IBBProgramID);
    } else IBBProgramGetProgramListForScorecard(0);

    IBBGroupGetCompleteGridData();
  }, []);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0)
      IBBProgramGetDataForProgramDashboard();
  }, [
    programDashboardFilter.ProgramID,
    programDashboardFilter.QuarterID,
    programDashboardFilter.PFIGroupIDs,
  ]);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0) {
      formatSectionAndCriteriaInputDataForDetailsScorecard();
    }
  }, [inputData]);

  function IBBProgramGetProgramListForScorecard(IBBProgramID: number) {
    if (IBBProgramID == 0) IBBProgramID = programDashboardFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = programDashboardFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setProgramDashboardFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            let filtered = result[0].filter(
              (item: any) => item.IBBProgramID == IBBProgramID
            );
            if (filtered.length > 0) {
              setProgramData(filtered[0]);
            }

            setQuarterList(result[2]);
            if (programDashboardFilter.QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setProgramDashboardFilter((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }

            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetDataForProgramDashboard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = programDashboardFilter.ProgramID;
    object.numericquarter = programDashboardFilter.QuarterID;
    object.pfigroupids = programDashboardFilter.PFIGroupIDs;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCondition/IBBConditionGetDataForConditionalHoldHistory",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            //setCriteriaList(result[0]);
            setInputData(result[1]);
            setTotalData(result[2]);

            const deepCopy1 = JSON.parse(JSON.stringify(result[0]));
            const deepCopy2 = JSON.parse(JSON.stringify(result[0]));
            setThisGridListDataWithoutFilters(deepCopy1);
            setCriteriaList(deepCopy2);
            setThisGridListData(deepCopy2);
            thisGridListDataRef.current = deepCopy2;
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function formatSectionAndCriteriaInputDataForDetailsScorecard() {
    let criteriaListLocal = [...criteriaList];
    for (let i = 0; i < criteriaListLocal.length; i++) {
      let PFIDealerID = criteriaListLocal[i].PFIDealerID;
      let IBBProgramCriteriaID = criteriaListLocal[i].IBBProgramCriteriaID;
      var filtered = inputData.filter(
        (item: any) =>
          item.PFIDealerID == PFIDealerID &&
          item.IBBProgramCriteriaID == IBBProgramCriteriaID
      );
      for (let j = 0; j < filtered.length; j++) {
        if (
          (getAccessSettings(2, 26) > 0 &&
            globalState.AppAccessLevelData.DID > 0) ||
          globalState.AppAccessLevelData.DID == 0
        ) {
          criteriaListLocal[i][
            "Q" + filtered[j].NumericQuarter + "ConditionalHoldAmount"
          ] = filtered[j].Amount;
        }
        criteriaListLocal[i][
          "Q" + filtered[j].NumericQuarter + "ConditionalHoldStatus"
        ] = filtered[j].Status;
        criteriaListLocal[i][
          "Q" + filtered[j].NumericQuarter + "ConditionalHoldStatusName"
        ] = filtered[j].StatusName;
        criteriaListLocal[i][
          "Q" + filtered[j].NumericQuarter + "ConditionText"
        ] = filtered[j].ConditionText;
      }
    }
    if (criteriaListLocal.length > 0) {
      criteriaListLocal.push({ Title: "Total" });
      for (let j = 0; j < totalData.length; j++) {
        if (
          (getAccessSettings(2, 26) > 0 &&
            globalState.AppAccessLevelData.DID > 0) ||
          globalState.AppAccessLevelData.DID == 0
        ) {
          criteriaListLocal[criteriaListLocal.length - 1][
            "Q" + totalData[j].NumericQuarter + "ConditionalHoldAmount"
          ] = totalData[j].TotalAmount;
        }
      }
    }

    setCriteriaList(criteriaListLocal);

    const deepCopy1 = JSON.parse(JSON.stringify(criteriaListLocal));
    const deepCopy2 = JSON.parse(JSON.stringify(criteriaListLocal));
    setThisGridListDataWithoutFilters(deepCopy1);
    setCriteriaList(deepCopy2);
    setThisGridListData(deepCopy2);
    thisGridListDataRef.current = deepCopy2;
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setCriteriaList(deepCopy);
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["", "D"]);

  useEffect(() => {
    SetSortingImage();
  }, [criteriaList]);

  function SetSortingImage() {
    if (criteriaList && criteriaList.length > 0 && document.getElementById("imgSortMarketName")) {
      (
        document.getElementById("imgSortMarketName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (
        document.getElementById("imgSortDealerName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Conditional Hold History</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div>
              <select
                className="select-md"
                value={programDashboardFilter.ProgramID}
                onChange={(e) => {
                  setProgramDashboardFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(Number(e.target.value));
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"programoption" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              {/* <select
              style={{ marginLeft: 5 }}
              className="select-md"
              value={programDashboardFilter.QuarterID}
              onChange={(e) =>
                setProgramDashboardFilter((prevState: any) => ({
                  ...prevState,
                  QuarterID: Number(e.target.value),
                }))
              }
            >
              <option value={0} key={"quarteroption" + 0}>
                YTD
              </option>
              {quarterList &&
                quarterList.map((Item: any, index: any) => (
                  <option value={Item.PID} key={"quarteroption" + Item.PID}>
                    {Item.Name}
                  </option>
                ))}
            </select> */}
            </div>

            {globalState.AppAccessLevelData.DID == 0 && (
              <select
                className="select-md"
                value={programDashboardFilter.PFIGroupIDs}
                onChange={(e) =>
                  setProgramDashboardFilter((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                  }))
                }
              >
                {groupList &&
                  groupList.map((Item: any, index: any) => (
                    <option value={Item.IBBGroupID} key={"groupoption" + index}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            )}
            <span></span>

            <a
              className="btn-primary"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblConditionalHoldHistory",
                  "ConditionalHoldHistory"
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>

          <div
            className="section-table remove-scroll"
            style={{ boxShadow: "none", padding: 0 }}
          >
            {criteriaList && criteriaList.length > 0 && (
              <ColumnFilterCheckboxList
                DataType={1}
                RefreshFilters={refreshFilters}
                ClearFilters={clearFilters}
                GridData={criteriaList}
                ColumnName={selectedColumnName}
                ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
                GetFilteredLists={getFilteredLists}
                ReturnAllFilterdLists={{}}
                ClickPosition={clickPosition}
                Orientation={"Center"}
                ColumnOrientation={[
                  { Name: "MarketName", Orientation: "Right" },
                ]}
              />
            )}

            <table
              className="part-head trend-table fixed-table auto-table tab-chs copa-in-d-table"
              id="tblConditionalHoldHistory"
            >
              <thead>
                <tr>
                  <th colSpan={3}></th>
                  <th colSpan={3}>Q1</th>
                  <th colSpan={3}>Q2</th>
                  <th colSpan={3}>Q3</th>
                  <th colSpan={3}>Q4</th>
                </tr>
                <tr>
                  <th>
                    {" "}
                    <span
                      className="c-pointer"
                      onClick={(e) => ShowColumnFilterList(e, "MarketName")}
                      data-function="ShowColumnFilterList"
                    >
                      Market
                    </span>
                    <a
                      onClick={() => LoadWithSelectedSort("MarketName")}
                      title="Sort By Market"
                    >
                      <span id="imgSortMarketName"></span>
                    </a>
                  </th>
                  <th className="col-imp-ch">
                    <span
                      className="c-pointer"
                      onClick={(e) => ShowColumnFilterList(e, "DealerName")}
                      data-function="ShowColumnFilterList"
                    >
                      Importer
                    </span>

                    <a
                      onClick={() => LoadWithSelectedSort("DealerName")}
                      title="Sort By Importer"
                    >
                      <span id="imgSortDealerName"></span>
                    </a>
                  </th>
                  <th>Criteria</th>
                  <th className="col-condition">Condition</th>
                  <th>Conditional Hold</th>
                  <th>Status</th>
                  <th className="col-condition">Condition</th>
                  <th>Conditional Hold</th>
                  <th>Status</th>
                  <th className="col-condition">Condition</th>
                  <th>Conditional Hold</th>
                  <th>Status</th>
                  <th className="col-condition">Condition</th>
                  <th>Conditional Hold</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={"crscdata" + "" + index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.MarketName}</td>
                          <td className="col-imp-ch">{item.DealerName}</td>
                          <td>{item.Title}</td>
                          <td className="col-condition">
                            {item.Q1ConditionText}
                          </td>
                          <td className="text-right">
                            {item.Q1ConditionalHoldAmount && (
                              <>
                                $
                                {item.Q1ConditionalHoldAmount?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </>
                            )}
                          </td>
                          <td
                            className={`
                               ${
                                 item.Q1ConditionalHoldStatus == 1
                                   ? "sig-green"
                                   : ""
                               }
                               ${
                                 item.Q1ConditionalHoldStatus == 2
                                   ? "sig-red"
                                   : ""
                               }
                          `}
                          >
                            {item.Q1ConditionalHoldStatusName}
                          </td>
                          <td className="col-condition">
                            {item.Q2ConditionText}
                          </td>
                          <td className="text-right">
                            {item.Q2ConditionalHoldAmount && (
                              <>
                                $
                                {item.Q2ConditionalHoldAmount?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </>
                            )}
                          </td>
                          <td
                            className={`
                               ${
                                 item.Q2ConditionalHoldStatus == 1
                                   ? "sig-green"
                                   : ""
                               }
                               ${
                                 item.Q2ConditionalHoldStatus == 2
                                   ? "sig-red"
                                   : ""
                               }
                          `}
                          >
                            {item.Q2ConditionalHoldStatusName}{" "}
                          </td>
                          <td className="col-condition">
                            {item.Q3ConditionText}
                          </td>
                          <td className="text-right">
                            {item.Q3ConditionalHoldAmount && (
                              <>
                                $
                                {item.Q3ConditionalHoldAmount?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </>
                            )}
                          </td>
                          <td
                            className={`
                               ${
                                 item.Q3ConditionalHoldStatus == 1
                                   ? "sig-green"
                                   : ""
                               }
                               ${
                                 item.Q3ConditionalHoldStatus == 2
                                   ? "sig-red"
                                   : ""
                               }
                          `}
                          >
                            {item.Q3ConditionalHoldStatusName}
                          </td>
                          <td className="col-condition">
                            {item.Q4ConditionText}
                          </td>
                          <td className="text-right">
                            {item.Q4ConditionalHoldAmount && (
                              <>
                                $
                                {item.Q4ConditionalHoldAmount?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </>
                            )}
                          </td>
                          <td
                            className={`
                               ${
                                 item.Q4ConditionalHoldStatus == 1
                                   ? "sig-green"
                                   : ""
                               }
                               ${
                                 item.Q4ConditionalHoldStatus == 2
                                   ? "sig-red"
                                   : ""
                               }
                          `}
                          >
                            {item.Q4ConditionalHoldStatusName}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
